import { Dialog } from '@base-ui/react/dialog';
import { Icon } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { type ComponentPropsWithoutRef, type Ref } from 'react';

type HeaderProps = ComponentPropsWithoutRef<'header'> & {
    closeRef?: Ref<HTMLButtonElement>;
};

export function Header({ children, className, closeRef, ...props }: HeaderProps) {
    return (
        <header className={cn('side-drawer__header', className)} {...props}>
            {children}
            <Dialog.Close ref={closeRef} className="side-drawer__close" aria-label="Close">
                <Icon name="x" />
            </Dialog.Close>
        </header>
    );
}
